import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { ServiceProvider } from "./../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-overview-plazamap",
  templateUrl: "shopper-overview-plazamap.html",
})
export class ShopperOverviewPlazamapPage {
  spaces: any = [1];
  plaza_id: any;
  plaza = "";
  themes: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public NavParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.plaza_id = this.NavParams.data.plaza_id;
    if (this.plaza_id == 1) {
      this.plaza = "A";
    } else if (this.plaza_id == 2) {
      this.plaza = "B";
    } else if (this.plaza_id == 3) {
      this.plaza = "C";
    } else if (this.plaza_id == 4) {
      this.plaza = "D";
    } else if (this.plaza_id == 5) {
      this.plaza = "E";
    } else if (this.plaza_id == 6) {
      this.plaza = "F";
    } else {
      this.plaza = this.plaza_id;
    }
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaList + "/" + this.plaza_id + "/spaces";
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.spaces = data;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link2 = this.services.URLPlazaList + "/" + this.plaza_id + "/themes";

      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.themes = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaList + "/" + this.plaza_id + "/spaces";
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.spaces = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link2 = this.services.URLPlazaList + "/" + this.plaza_id + "/themes";

      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.themes = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
    refresher.complete();
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-overview-plazamap/shopper-overview-plazamap.ts